<template>
  <i :class="classes" :style="styles" @click="onClick">
    <component :is="kebabizeName" />
  </i>
</template>
<script>
import { defineComponent, ref, computed, getCurrentInstance } from 'vue';
import { CONSTANTS } from '@/components/constants';

export default defineComponent({
  name: `${CONSTANTS.COMMON.COMPONENT_PREFIX}-icon`,
  props: {
    name: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 24
    }
  },
  emits: ['click'],
  setup(props, { emit, attrs }) {
    const isAni = ref(false);
    const listeners = attrs;
    const classes = computed(() => ({
      [`${CONSTANTS.COMMON.COMPONENT_PREFIX}-icon`]: true,
      [`${props.name.toLowerCase()}`]: true,
      [`${CONSTANTS.COMMON.COMPONENT_PREFIX}-icon-pointer`]: listeners.click,
      [`${CONSTANTS.COMMON.COMPONENT_PREFIX}-icon-ani`]: isAni.value
    }));
    const iconSize = computed(() => {
      return props.size || '24px';
    });
    const styles = computed(() => ({
      'font-size': iconSize.value + 'px'
    }));
    const kebabizeName = computed(() => {
      return props.name
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/\s+/g, '-')
        .replace(/_{1,}/g, '-')
        .toLowerCase();
    });

    const onClick = (e) => {
      if (props.name.toLowerCase() === 'rirefresh' || props.name.toLowerCase() === 'ri-refresh') {
        isAni.value = true;
        setTimeout(() => {
          isAni.value = false;
        }, 600);
      }
      emit('click', e);
    };

    return {
      classes,
      styles,
      iconSize,
      kebabizeName,
      onClick
    };
  }
});
</script>

<style lang="scss">
.sc-icon{
  user-select: none;
}
.#{$componentPrefix}-icon {
  height: 1em;
  width: 1em;
  line-height: 1em;
  text-align: center;
  display: inline-block;
  position: relative;
  fill: currentColor;
  vertical-align: middle;
  &-pointer {
    cursor: pointer;
  }

  &-rirefresh,
  &-ri-refresh {
    cursor: pointer;
    svg {
      position: relative;
      right: -1px;
    }
  }
  &-ani {
    animation-name: icon-rotation;
    animation-duration: 0.6s;
    animation-timing-function: linear;
    animation-fill-mode: both;
  }
}

@keyframes icon-rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
